import theme from "@/styles/themes/theme";
import { css } from "@emotion/react";

export const styles = {
  container: css`
    padding-top: 86px;
    background-color: #f5f5f5;
    padding-bottom: 86px;

    ${theme.breakpoints.down("lg")} {
      padding-top: 48px;
    }
  `,
  header_container: css`
    flex-direction: row;
    padding-left: 80px;
    padding-right: 80px;
    margin-bottom: 54px;
    justify-content: space-between;
    align-items: center;
    gap: 48px;

    ${theme.breakpoints.down("lg")} {
      flex-direction: column;
      padding-left: 32px;
      padding-right: 32px;
      margin-bottom: 54px;
    }

    ${theme.breakpoints.down("md")} {
      padding-left: 24px;
      padding-right: 24px;
      margin-bottom: 48px;
    }
  `,
  title: css`
    font-size: 32px;
    font-weight: 600;
    line-height: 38.73px;
    text-align: left;
    color: #0045b5;
    ${theme.breakpoints.down("sm")} {
    }
  `,
  category: css`
    font-size: 32px;
    font-weight: 600;
    line-height: 38.73px;
    text-align: left;
    color: #ff8b00;
    ${theme.breakpoints.down("sm")} {
    }
  `,
  button: css`
    background-color: #0045b50d;
    height: 52px;
    text-transform: none;
    font-weight: 600;
    font-size: 16px;
    border-radius: 8px;
    width: fit-content;
    color: #0045b5;
    border-color: #0045b5;

    &:hover {
      background-color: #0045b521;
      border-color: #0045b5;
    }
  `
};
